<div class="display">
  <header>
    <span class="room">{{ state?.room?.name }}</span>
    <span class="clock">{{ clock }}</span>
  </header>

  @switch (status) {
    @case ('not-set-up') {
      <div class="message">
        <h1>Diese Anzeige ist nicht eingerichtet</h1>
        <p>Im Back Office unter „Anzeigen“ eine neue Anzeige anlegen und den Einrichtungs-Link auf diesem Gerät öffnen.</p>
      </div>
    }
    @case ('loading') {
      <div class="message"><p>Wird geladen …</p></div>
    }
    @default {
      @if (status === 'offline') {
        <div class="offline">Keine Verbindung – neuer Versuch in Kürze …</div>
      }
      @if (state && state.courses.length > 0) {
        <div class="courses" [class.multiple]="state.courses.length > 1">
          @for (course of state.courses; track course.cid) {
            <section class="course">
              <h1>{{ course.name }} {{ course.description }}</h1>
              <h2>{{ course.begin }}–{{ course.end }}</h2>
              <img [src]="course.qr" alt="Check-In-Code {{ course.name }}" />
              <p>Mit der Li-Dance App scannen: <b>Check-In</b></p>
            </section>
          }
        </div>
      } @else if (state) {
        <div class="message">
          <h1>Kein Kurs im Check-In-Zeitraum</h1>
          @if (state.next) {
            <p>{{ nextText }}</p>
          }
        </div>
      }
    }
  }
</div>
